export default "__VITE_ASSET__DTwYHlsL__"